import React, { useRef, useEffect, useState } from 'react';
import { useFontLoader } from '../../../../dummies/RichTextEditor/useFontLoader';
import { heritageColors } from '../../../../heritageTheme.ts';

const Callout = ({ data = { notices: [] }, title = 'לוח מודעות', showTitle = true }) => {
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const firstSetRef = useRef(null);
  const [needsScroll, setNeedsScroll] = useState(false);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const activeNotices = (data.notices || []).filter(
    n => !n.expiryDate || new Date(n.expiryDate) > now
  );

  const allNoticesHtml = activeNotices.map(n => n.content).join(' ') || '';
  useFontLoader(allNoticesHtml);

  useEffect(() => {
    const checkScroll = () => {
      if (!containerRef.current || !firstSetRef.current || activeNotices.length === 0) return;
      const containerHeight = containerRef.current.clientHeight;
      const contentHeight = firstSetRef.current.offsetHeight;
      setNeedsScroll(containerHeight > 0 && contentHeight > containerHeight + 2);
    };
    const timer = setTimeout(checkScroll, 100);
    const resizeObserver = new ResizeObserver(checkScroll);
    if (containerRef.current) resizeObserver.observe(containerRef.current);
    return () => { clearTimeout(timer); resizeObserver.disconnect(); };
  }, [activeNotices]);

  const accentColor = heritageColors.gold || '#D4AF37';

  const renderItems = (notices, keyPrefix = '') =>
    notices.map((notice) => (
      <li
        key={`${keyPrefix}${notice.id}`}
        data-notice-item
        style={{
          borderRight: `4px solid ${accentColor}`,
          borderRadius: '0 0.5em 0.5em 0',
          padding: '0.6em 0.75em',
          backgroundColor: 'rgba(255,255,255,0.55)',
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}
      >
        <div
          style={{ fontSize: '0.75em', color: heritageColors.navy || '#1a3a5c', lineHeight: 1.55 }}
          dangerouslySetInnerHTML={{ __html: notice.content }}
        />
      </li>
    ));

  return (
    <div style={{
      padding: '20px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
      boxSizing: 'border-box',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: `0.0625em solid ${heritageColors.border || '#D7CCC8'}`,
          paddingBottom: '8px',
          marginBottom: '12px',
        }}>
          <span className="material-symbols-outlined" style={{ color: heritageColors.navy || '#1a3a5c', fontSize: '1.1em' }}>campaign</span>
          <h3 style={{ margin: 0, fontWeight: 'bold', color: heritageColors.navy || '#1a3a5c', fontSize: '0.875em' }}>{title}</h3>
        </div>
      )}

      {activeNotices.length === 0 ? (
        <p style={{ color: heritageColors.slate || '#795548', fontSize: '0.875em' }}>אין מודעות להצגה</p>
      ) : (
        <div ref={containerRef} style={{ overflow: 'hidden', flex: 1, position: 'relative' }}>
          {needsScroll && (
            <style>{`
              @keyframes scrollNoticesCallout {
                0% { transform: translateY(0); }
                100% { transform: translateY(calc(-100% / 3)); }
              }
            `}</style>
          )}
          <div ref={contentRef} style={{
            animation: needsScroll ? 'scrollNoticesCallout 30s linear infinite' : 'none',
          }}>
            <ul ref={firstSetRef} style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {renderItems(activeNotices)}
            </ul>
            {needsScroll && (
              <>
                <ul style={{ listStyle: 'none', padding: 0, margin: '10px 0 0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {renderItems(activeNotices, 'dup1-')}
                </ul>
                <ul style={{ listStyle: 'none', padding: 0, margin: '10px 0 0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {renderItems(activeNotices, 'dup2-')}
                </ul>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Callout;
